<div mat-dialog-title class="title-dialog">
    <span class="ff-bold fs-18">{{ dialogTitle }}</span>
</div>
<div mat-dialog-content>
    <mat-radio-group [(ngModel)]="selectedOption" class="d-flex flex-column" color="primary">
        <mat-radio-button *ngFor="let element of dialogOptions" [value]="element.value.accountId">
            <div class="user-details">
                <span class="fs-13 ff-medium">{{ element.label }} <span *ngIf="element.label_extended" class="extendedLabel ff-regular"> | {{ element.label_extended }}</span></span>
            </div>
        </mat-radio-button>
    </mat-radio-group>
</div>

<div mat-dialog-actions align="end" class="action-dialog">
    <button mat-dialog-close>Cancel</button>
    <button class="tse-btn-primary" [disabled]="!selectedOption" [class.disabled]="!selectedOption"
            (click)="handleResponse()">Done
    </button>
</div>